export interface CreateNewProjectInput {
  ownerId: string;
  projectName: string;
  parentId: string;
}
